import { render, staticRenderFns } from "./TimeStudyButton.vue?vue&type=template&id=55eae37a&scoped=true&"
import script from "./TimeStudyButton.vue?vue&type=script&lang=js&"
export * from "./TimeStudyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eae37a",
  null
  
)

export default component.exports